import {
	FormControl,
	FormDescription,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from "@/components/ui/form";
import { Label } from "@/components/ui/label";
import type { InputT } from "@/types/database/forms";
import { useFormContext } from "react-hook-form";

import { ui } from "../ui";

interface Props {
	input: InputT;
}

const SingleChoice = ({ input }: Props) => {
	const { control } = useFormContext();

	return (
		<ui.Card className="p-4">
			<FormField
				control={control}
				name={input.input_id}
				render={({ field }) => (
					<FormItem>
						<FormLabel>
							<Label>{input.input_label}</Label>
						</FormLabel>
						{input.input_description && (
							<FormDescription>{input.input_description}</FormDescription>
						)}
						<FormControl>
							<ui.RadioGroup
								onValueChange={field.onChange}
								value={field.value}
								className="flex flex-col gap-y-3"
							>
								{input.options?.map((o) => (
									<div
										className="flex justify-start items-center gap-2 hover:bg-slate-100 hover:shadow-sm pl-2 rounded-md transition-all duration-200 hover:cursor-pointer"
										key={o}
									>
										<ui.RadioGroupItem
											value={o}
											key={o}
											id={o}
											className="p-2"
										/>
										<ui.Label className="py-4 w-full" htmlFor={o}>
											{o}
										</ui.Label>
									</div>
								))}
							</ui.RadioGroup>
						</FormControl>
						<FormMessage />
					</FormItem>
				)}
			/>
		</ui.Card>
	);
};

export default SingleChoice;
